import { useEffect, useState } from "react";
import { Box, Dialog, Typography, Button } from "@mui/material";
import DateWithClear from "Components/UI/Form/DateWithClear";
import dayjs from "dayjs";
import { setInterestStopDate } from "API/swesum";
import { LoadingButton } from "@mui/lab";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 2,
  padding: 4,
  width: "100&",
  height: "100%",
};

export default function InterestStopDateModal({
  open,
  onClose,
  invoice,
  setInvoice,
}) {
  const { openSuccess, openError } = usePopupNotificationContext();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleConfirm = async () => {
    setLoading(true);

    try {
      var date = selectedDate;

      if (selectedDate === "Invalid Date") date = null;

      var res = await setInterestStopDate(invoice?.Id, date);

      if (res.status === 200) {
        setInvoice({ ...invoice, InterestStopDate: date });
        openSuccess(res.data.Message, 5000);
      } else {
        openError(res.data.Message, 5000);
      }
    } catch {
      openError("Något gick fel.");
      console.error(res);
    } finally {
      setLoading(false);
    }

    onClose();
  };

  useEffect(() => {
    setSelectedDate(dayjs(invoice?.InterestStopDate).format("YYYY-MM-DD"));
  }, [open]);

  return (
    <>
      <Dialog open={open}>
        <Box sx={style}>
          <Typography variant="h5" fontWeight={"bold"}>
            Justera Räntestoppdatum
          </Typography>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            width={"100%"}
          >
            <Typography fontWeight={"medium"} fontSize={16} width={"50%"}>
              Datum:
            </Typography>
            <DateWithClear
              onChange={(value) => {
                setSelectedDate(dayjs(value).format("YYYY-MM-DD"));
              }}
              value={dayjs(selectedDate)}
            />
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={2}
            justifyContent={"space-around"}
            height={45}
            width={"100%"}
          >
            <Button
              sx={{
                backgroundColor: "transparent",
                outline: "1px solid #1976d2",
                color: "#1976d2",
                width: "100%",
              }}
              onClick={() => onClose()}
            >
              Avbryt
            </Button>
            <LoadingButton
              variant="contained"
              onClick={handleConfirm}
              sx={{ backgroundColor: "#1976d2", color: "white", width: "100%" }}
              loading={loading}
            >
              Bekräfta
            </LoadingButton>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
